import request from '@/utils/request'

export function getPaymentSandboxOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.getSandboxOrderList',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getPaymentSandboxOrderDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.getSandboxOrderDetail',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
